module.exports = __webpack_public_path__ + "static/media/settle_gray.a9db0550.svg";